import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './SecurityModal.scss';
import { ProfileEditModal } from './ProfileEditModal';
import { validateUsernameData } from './validation';

interface SecurityModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (data: Record<string, any>) => Promise<void>;
  initialData: {
    currentUsername: string;
  };
}

export const SecurityModal: React.FC<SecurityModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
  initialData,
}) => {
  const { t } = useTranslation('profile');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: Record<string, any>) => {
    setIsSubmitting(true);
    try {
      await onSuccess(data);
      onClose();
    } catch (error) {
      console.error('Error updating security info:', error);
    }
    setIsSubmitting(false);
  };

  return (
    <ProfileEditModal
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title={t('sections.security.title')}
      validate={validateUsernameData}
      isSubmitting={isSubmitting}
    >
      <div className="form-groups-grid">
        <div className="form-group">
          <label htmlFor="currentUsername">{t('sections.security.currentUsername')}*</label>
          <input
            type="text"
            id="currentUsername"
            name="currentUsername"
            defaultValue={initialData.currentUsername}
            disabled
          />
          <div className="helper-text">{t('sections.security.usernameHint')}</div>
        </div>

        <div className="form-group">
          <label htmlFor="newUsername">{t('sections.security.newUsername')}*</label>
          <input
            type="text"
            id="newUsername"
            name="newUsername"
            required
            minLength={4}
            maxLength={20}
            pattern="^[^@]*$"
          />
          <div className="helper-text">{t('sections.security.usernameHint')}</div>
        </div>
      </div>
    </ProfileEditModal>
  );
};
